import api from './api';
import { getToken, setToken, setUser } from './auth';
import { encerrarSessao, segundosParaExpirar } from './sessao';

// O token vale 1 hora. Quem está usando o sistema não pode cair no meio do trabalho:
// com menos de RENOVAR_ABAIXO_DE segundos restantes e atividade recente, troca por um
// novo. Quem deixou a aba parada e o token venceu vai para o login assim que volta à
// aba, em vez de ver uma tela que parece funcionar e falha a cada clique.
const RENOVAR_ABAIXO_DE = 20 * 60;
const ATIVIDADE_RECENTE_MS = 10 * 60 * 1000;
const INTERVALO_MS = 30 * 1000;

let ultimaAtividade = Date.now();
let renovando = null;

const renovar = () => {
  if (!renovando) {
    renovando = api.post('/usuarios/renovar-sessao')
      .then(({ data }) => {
        setToken(data.token);
        setUser(data.user);
        window.dispatchEvent(new Event('userUpdated'));
      })
      // 401 já foi tratado no interceptor do api; falha de rede tenta de novo depois.
      .catch(() => {})
      .finally(() => { renovando = null; });
  }
  return renovando;
};

const checar = () => {
  if (!getToken()) return;
  const restante = segundosParaExpirar();
  if (restante <= 0) {
    encerrarSessao('expirada');
    return;
  }
  const ativo = Date.now() - ultimaAtividade < ATIVIDADE_RECENTE_MS;
  if (restante < RENOVAR_ABAIXO_DE && ativo && document.visibilityState === 'visible') {
    renovar();
  }
};

export const iniciarMonitorDeSessao = () => {
  const marcarAtividade = () => { ultimaAtividade = Date.now(); };
  const aoVoltarParaAba = () => {
    if (document.visibilityState === 'visible') {
      marcarAtividade();
      checar();
    }
  };
  // Outra aba saiu do sistema (ou a sessão caiu lá): esta acompanha.
  const aoMudarEmOutraAba = (evento) => {
    if (evento.key === 'token' && evento.oldValue && !evento.newValue) encerrarSessao('outraAba');
  };

  const eventosDeAtividade = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
  eventosDeAtividade.forEach((nome) => window.addEventListener(nome, marcarAtividade, { passive: true }));
  document.addEventListener('visibilitychange', aoVoltarParaAba);
  window.addEventListener('focus', aoVoltarParaAba);
  window.addEventListener('storage', aoMudarEmOutraAba);
  const intervalo = setInterval(checar, INTERVALO_MS);
  checar();

  return () => {
    eventosDeAtividade.forEach((nome) => window.removeEventListener(nome, marcarAtividade));
    document.removeEventListener('visibilitychange', aoVoltarParaAba);
    window.removeEventListener('focus', aoVoltarParaAba);
    window.removeEventListener('storage', aoMudarEmOutraAba);
    clearInterval(intervalo);
  };
};
